import { useMemo } from "react";
import { useScreenConfig } from "@/hooks/useScreenConfig";
import { useScheduledConfig } from "@/hooks/useScheduledConfig";
import { Stage } from "@/components/Stage";
import { ComingSoon } from "@/components/ComingSoon";

export function App() {
  const screenId = useMemo(() => {
    const params = new URLSearchParams(window.location.search);
    return params.get("screen") || "1";
  }, []);

  const { config: stored, refetch } = useScreenConfig(screenId);
  // What should play right now: the stored config, with the active schedule slot's content if any.
  const config = useScheduledConfig(stored);

  if (!config) {
    return (
      <div id="status" className="show">
        Loading configuration...
      </div>
    );
  }

  // enabled is optional for configs stored before this field existed —
  // undefined means enabled, so an older screen never regresses to blank.
  if (config.enabled === false) {
    return <ComingSoon screenId={screenId} />;
  }

  return <Stage screenId={screenId} config={config} onRefetchConfig={refetch} />;
}
